<template lang="pug">
  div(:style="positionStyle").wrap-item-doodle-image
    ItemDoodleWrapper(:doodle="doodle" :hostUid="hostUid"
      @playDoodleSound="playDoodleSound")
      div(:style="rectStyle").wrap-img.f.fh
        img(:src="doodle.imgURL").object-fit-cover
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-doodle-image {
  position: absolute;
  .wrap-img {
    overflow: hidden;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import ItemDoodleWrapper from '@/components/item/ItemDoodleWrapper'

export default {
  components: {
    ItemDoodleWrapper
  },
  props: {
    doodle: {
      type: Object,
      required: true
    },
    hostUid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      positionStyle: null,
      rectStyle: null,
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  created () {
    this.positionStyle = `top: ${this.doodle.top}%; left: ${this.doodle.left}%;`
      // + ` width: ${this.doodle.width / this.doodle.slideImgWidth * 100}%;`
      // + ` height: ${this.doodle.height / this.doodle.slideImgHeight * 100}%;`
      + ` width: ${this.doodle.width}px;`
      + ` height: ${this.doodle.height}px;`

    this.rectStyle = `width: ${this.doodle.width}px; height: ${this.doodle.height}px;`

    // this.rectStyle = `width: ${this.doodle.width / this.doodle.slideImgWidth * 100}%;`
    //   + ` height: ${this.doodle.height / this.doodle.slideImgHeight * 100}%;`
  },
  methods: {
    playDoodleSound (param) {
      this.$emit('playDoodleSound', param)
    }
  }
}
</script>
